import React, { useEffect, useState } from "react";
import { Button, Form, Col, Row, Modal, ButtonToolbar } from "react-bootstrap";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../_metronic/_partials/controls";
import { LayoutSplashScreen } from "../../../_metronic/layout";
import { RoleTable } from "./RoleTable";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import {
  resetData,
  selectRole,
  selectLoading,
  selectPageNo,
  selectPageSize,
  selectTotalRecord,
  fetchRole,
  selectRoleModal,
  fetchRoleModal,
  addRole,
  addRoleDuplicate,
  selectPermissionRole,
} from "./userSlice";
import {
  checkPermision,
  getValueType,
  showDialog,
  showErrorDialog,
  showSuccessDialog,
  useForceUpdate,
} from "../../utility";
import BootstrapTable from "react-bootstrap-table-next";
import SVG from "react-inlinesvg";
import Select from "react-select";
import {
  sortCaret,
  headerSortingClasses,
  toAbsoluteUrl,
} from "../../../_metronic/_helpers";
import {
  selectPagination,
  selectUser,
} from "../../modules/Auth/_redux/authRedux";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";

// MUI
import {
  fade,
  withStyles,
  makeStyles,
  createMuiTheme,
} from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";

const useStylesReddit = makeStyles((theme) => ({
  root: {
    border: "1px solid #e2e2e1",
    overflow: "hidden",
    borderRadius: 4,
    backgroundColor: "#FFFFFF",
    transition: theme.transitions.create(["border-color", "box-shadow"]),
    "&:hover": {
      backgroundColor: "#fff",
    },
    "&$focused": {
      backgroundColor: "#fff",
      boxShadow: `${fade(theme.palette.primary.main, 0.25)} 0 0 0 2px`,
      borderColor: theme.palette.primary.main,
    },
  },
  focused: {},
}));

function RedditTextField(props) {
  const classes = useStylesReddit();

  return (
    <TextField InputProps={{ classes, disableUnderline: true }} {...props} />
  );
}
const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexWrap: "wrap",
  },
  margin: {
    margin: theme.spacing(1),
  },
}));

export const RoleTab = ({ active }) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();
  const data = useSelector(selectRole);
  const dataRoleModal = useSelector(selectRoleModal);
  const loading = useSelector(selectLoading);
  const pageNo = useSelector(selectPageNo);
  const pageSize = useSelector(selectPageSize);
  const totalRecord = useSelector(selectTotalRecord);
  const user = useSelector(selectUser);
  const forceUpdate = useForceUpdate();
  const paginationSet = useSelector(selectPagination);
  const permission = useSelector(selectPermissionRole);

  // Filter
  const [roleName, setRoleName] = useState("");
  const [vendor, setVendor] = useState("");
  const [roleCopy, setRoleCopy] = useState("");
  const [force, setForce] = useState(false);

  const [state, setState] = useState({
    checkedA: false,
  });
  const [value, setValue] = useState(0);

  useEffect(() => {
    // Reset on first load
    {
      active === "Role Management" && handleSearch();
    }
  }, [active]);

  useEffect(() => {
    // Add number
    if (force === true) {
      handleSearch();
      forceUpdate();
      setForce(false);
    }
  }, [force]);

  const handleSearch = async () => {
    let params = {};
    fields.forEach((item) => {
      params[item.params] = item.value;
    });
    params.is_enable = value === 0 ? "Y" : "N";

    params.pageNo = 1;
    params.pageSize = paginationSet;

    try {
      const response = await dispatch(fetchRole(params));
      console.log(response, "response");
      if (response.payload.data.status === 200) {
      } else if (
        response.payload.error === "10008" ||
        response.payload.error === "10009"
      ) {
        const action = await showErrorDialog(response.payload.message);
        await history.push("/logout");
      } else {
        showErrorDialog(response.payload.data.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
      console.log(error, "masukcatch");
    }
  };

  const handleTableChange = async (
    type,
    { page, sizePerPage, sortField, sortOrder, data }
  ) => {
    if (type === "pagination") {
      let params = {};
      fields.forEach((item) => {
        params[item.params] = item.value;
      });
      params.is_enable = value === 0 ? "Y" : "N";
      params.pageNo = page;
      params.pageSize = sizePerPage;
      try {
        const response = await dispatch(fetchRole(params));
        if (response.payload.status === 200) {
        } else if (
          response.payload.error === "10008" ||
          response.payload.error === "10009"
        ) {
          const action = await showErrorDialog(response.payload.message);
          await history.push("/logout");
        } else {
          showErrorDialog(response.payload.message);
        }
      } catch (error) {
        showErrorDialog(error.message);
      }
    } else {
      let result;
      if (sortOrder === "asc") {
        result = data.sort((a, b) => {
          if (a[sortField] > b[sortField]) {
            return 1;
          } else if (b[sortField] > a[sortField]) {
            return -1;
          }
          return 0;
        });
      } else {
        result = data.sort((a, b) => {
          if (a[sortField] > b[sortField]) {
            return -1;
          } else if (b[sortField] > a[sortField]) {
            return 1;
          }
          return 0;
        });
      }
    }
  };

  // paramater
  const [typeOptions, setTypeOptions] = useState([
    {
      id: "1",
      value: "role_description",
      label: "Name",
      show: "Y",
      editor: "text",
    },
    {
      id: "1",
      value: "created_user",
      label: "Created By",
      show: "Y",
      editor: "text",
    },
  ]);

  // paket filter

  const [btnHide, setBtnHide] = useState(false);

  const data_filter = typeOptions.filter((element) => element.show === "Y");

  const [fields, setFields] = useState([
    {
      id: "",
      value: "",
      params: "",
      label: "",
      add: "N",
      editor: "text",
      remove: "N",
    },
  ]);

  function handleRemarkChange(i, event) {
    const values = [...fields];
    values[i].value = event.target.value;
    setFields(values);
  }

  function handleAdd(i, event) {
    const values = [...fields];

    if (values[i].params === "") {
      showDialog("Please select filter first");
    } else {
      // update disabled field
      values[i].add = "Y";
      values[i].remove = "Y";
      setFields(values);
      //   change status show

      const result = typeOptions.map((item) => {
        if (item.value === values[i].params) {
          return { ...item, show: "N" };
        }
        return item;
      });

      setTypeOptions(result);

      const filteredShow = result.filter((item) => item.show === "Y");
      if (filteredShow.length <= 1) {
        setBtnHide(true);
      } else {
        setBtnHide(false);
      }

      //   push new paramater
      values.push({
        id: "",
        value: "",
        params: "",
        label: "",
        add: "N",
        editor: "text",
        remove: "N",
      });
      setFields(values);
    }
  }

  function handleRemove(i) {
    const values = [...fields];

    const result = typeOptions.map((item) => {
      if (item.value === values[i].params) {
        return { ...item, show: "Y" };
      }
      return item;
    });

    setTypeOptions(result);

    const filteredShow = result.filter((item) => item.show === "Y");
    if (filteredShow.length >= 1) {
      setBtnHide(false);
    } else {
      setBtnHide(true);
    }

    values.splice(i, 1);
    setFields(values);
  }

  const handleTypeChange = (i, event) => {
    const values = [...fields];
    values[i].params = event.value;
    values[i].id = event.id;
    values[i].editor = event.editor;
    values[i].label = event.label;
    setFields(values);
  };

  // paket filter bawah 

  // Func Create
  const [show, setShow] = useState(false);

  const handleClose = () => {
    setFormValues({
      role_description: {
        value: "",
        error: false,
        errorMessage: "This field is required",
      },
    });
    setRoleCopy("");
    setShow(false);
  };
  const handleShow = () => setShow(true);

  const [formValues, setFormValues] = useState({
    role_description: {
      value: "",
      error: false,
      errorMessage: "This field is required",
    },
  });

  const handleChangeForm = (e) => {
    const { name, value } = e.target;
    setFormValues({
      ...formValues,
      [name]: {
        ...formValues[name],
        value,
      },
    });
  };

  const validatePost = (e) => {
    let isValid = true;

    const formFields = Object.keys(formValues);
    let newFormValues = { ...formValues };

    for (let index = 0; index < formFields.length; index++) {
      const currentField = formFields[index];
      const currentValue = formValues[currentField].value;

      if (currentValue === "") {
        newFormValues = {
          ...newFormValues,
          [currentField]: {
            ...newFormValues[currentField],
            error: true,
          },
        };
        isValid = false;
      } else {
        newFormValues = {
          ...newFormValues,
          [currentField]: {
            ...newFormValues[currentField],
            error: false,
          },
        };
      }
    }

    setFormValues(newFormValues);
    return isValid;
  };

  const handleSave = async () => {
    if (
      formValues.role_description.value.includes("<script>") ||
      formValues.role_description.value.includes("</script>")
    ) {
      return showErrorDialog("please don't input value <script>");
    }
    
    if (!validatePost()) {
      return;
    }
    const params = {
      role_description: formValues.role_description.value,
      // copy_role_id: roleCopy,
    };

    const paramsDuplicate = {
      role_description: formValues.role_description.value,
      copy_role_id: roleCopy,
    };

    if (state.checkedA === false) {
      callApiRole(params);
    } else {
      callApiRoleDuplicate(paramsDuplicate);
    }
  };

  const callApiRole = async (params) => {
    try {
      const response = await dispatch(addRole(params));
      console.log(response, "response");
      if (response.payload.status === 200) {
        const action = await showSuccessDialog(response.payload.data.message);
        if (action.isConfirmed)
          await history.push(
            `/administration/management-user/role/edit/${response.payload.data.data.role_id}`,
            { params: response.payload.data.data.role_description }
          );
      } else {
        showErrorDialog(response.payload.data.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
      console.log(error, "masukcatch");
    }
  };

  const callApiRoleDuplicate = async (params) => {
    try {
      const response = await dispatch(addRoleDuplicate(params));
      console.log(response, "response");
      if (response.payload.status === 200) {
        const action = await showSuccessDialog(response.payload.data.message);
        if (action.isConfirmed)
          await history.push(
            `/administration/management-user/role/edit/${response.payload.data.data.role_id}`,
            { params: response.payload.data.data.role_description }
          );
      } else {
        showErrorDialog(response.payload.data.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
      console.log(error, "masukcatch");
    }
  };

  //   func table

  const handleRoleChange = (e) => {
    if (e === null) {
      e = undefined;
      setRoleCopy("");
    } else {
      setRoleCopy(e.target.value);
    }
  };

  const dataOptions = dataRoleModal.map((e) => {
    return {
      value: e.role_id,
      label: e.role_description,
    };
  });

  const handleChange = (name) => (event) => {
    setState({ ...state, [name]: event.target.checked });
  };

  const handleChangeTab = (event, newValue) => {
    setValue(newValue);
    forceUpdate();
    setForce(true);
  };
  return loading ? (
    <LayoutSplashScreen />
  ) : (
    <>
      <div>
        <Card>
          <CardBody>
            {checkPermision(permission, "CREATE") && (
              <Button
                className="btn btn-primary my-btn-primary-dark text-bold mb-5"
                onClick={handleShow}
              >
                New Role
              </Button>
            )}
            {fields.map((field, idx) => {
              return (
                <div key={`${field}-${idx}`}>
                  <Form.Group as={Row}>
                    <Form.Label column sm={1}>
                      {idx === 0 && <b>Search By</b>}
                    </Form.Label>

                    <Col sm={3}>
                      {fields[idx].add === "N" && (
                        <Select
                          // isClearable={true}
                          options={data_filter}
                          value={getValueType(field.params, typeOptions)}
                          placeholder="Select Field"
                          // onChange={handleTypeChange}
                          onChange={(e) => handleTypeChange(idx, e)}
                        />
                      )}
                      {fields[idx].add === "Y" && (
                        <Form.Control
                          type="text"
                          value={fields[idx].label}
                          disabled
                        />
                      )}
                    </Col>
                    <Col sm={3}>
                      {field.editor === "text" && (
                        <Form.Control
                          type="text"
                          placeholder="Enter text"
                          value={field.value || ""}
                          onChange={(e) => handleRemarkChange(idx, e)}
                        />
                      )}
                    </Col>
                    <Col sm={3} className=" m-0 p-0">
                      {fields[idx].remove === "Y" && (
                        <div
                          className="btn btn-icon btn-primary btn-hover-primary btn-sm mr-3"
                          onClick={() => handleRemove(idx)}
                        >
                          <span className="svg-icon svg-icon-md svg-icon-light">
                            <SVG
                              src={toAbsoluteUrl("/media/svg/icons/New/X.svg")}
                            />
                          </span>
                        </div>
                      )}

                      {btnHide === false && fields.length - 1 === idx && (
                        <Button
                          className="mr-3"
                          variant="outline-primary"
                          onClick={(e) => handleAdd(idx, e)}
                        >
                          Add
                        </Button>
                      )}

                      {fields.length - 1 === idx && (
                        <Button
                          className="mr-3"
                          variant="primary"
                          onClick={handleSearch}
                        >
                          Search
                        </Button>
                      )}
                    </Col>
                  </Form.Group>
                </div>
              );
            })}

            <>
              <Tabs
                value={value}
                onChange={handleChangeTab}
                indicatorColor="primary"
                textColor="primary"
              >
                <Tab label="Enabled" />
                <Tab label="Disabled" />
              </Tabs>
              {value === 0 && (
                <RoleTable
                   data={data === null ? [] : data}
                  page={pageNo}
                  sizePerPage={pageSize}
                  totalSize={totalRecord}
                  onTableChange={handleTableChange}
                  loading={loading}
                  handleSearch={handleSearch}
                />
              )}
              {value === 1 && (
                <RoleTable
                   data={data === null ? [] : data}
                  page={pageNo}
                  sizePerPage={pageSize}
                  totalSize={totalRecord}
                  onTableChange={handleTableChange}
                  loading={loading}
                  handleSearch={handleSearch}
                />
              )}
            </>
          </CardBody>
        </Card>

        {/* Modal Create */}
        <Modal
          size="xs"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          show={show}
          onHide={handleClose}
        >
          <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-vcenter text-white">
              New Role
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <RedditTextField
              label="Role Name"
              className={classes.margin}
              variant="filled"
              id="reddit-input"
              size="small"
              fullWidth
              name="role_description"
              value={formValues.role_description.value}
              onChange={handleChangeForm}
              error={formValues.role_description.error}
              helperText={
                formValues.role_description.error &&
                formValues.role_description.errorMessage
              }
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={state.checkedA}
                  onChange={handleChange("checkedA")}
                  value="checkedA"
                  className="ml-3"
                />
              }
              label="Copy Role"
            />
            {state.checkedA === true && (
              <TextField
                select
                label="Copy Role"
                className={classes.margin}
                value={roleCopy}
                onChange={handleRoleChange}
                // SelectProps={{
                //   MenuProps: {
                //     className: classes.menu,
                //   },
                // }}
                margin="normal"
                variant="filled"
                // size="small"
              >
                {dataOptions.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem>
                ))}
              </TextField>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleClose}>
              Close
            </Button>
            <Button variant="primary" onClick={handleSave}>
              Save
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    </>
  );
};
